import React from "react";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import { trackPhoneClick, trackWhatsAppClick } from "../utils/analytics";

const phoneNumber = "+35796613191";
const whatsappLink =
  "https://wa.me/35796613191?text=Hello,%20I%20would%20like%20to%20book%20a%20taxi.";

export default function MobileCTABar({ hidden = false }) {
  if (hidden) {
    return null;
  }

  return (
    <>
      <div className="md:hidden" aria-hidden="true" style={{ height: "calc(88px + env(safe-area-inset-bottom))" }} />
      <div
        className="fixed inset-x-0 bottom-0 z-[70] border-t border-yellow-400/25 bg-[#050505]/95 px-4 pt-3 shadow-[0_-18px_45px_rgba(0,0,0,0.45)] backdrop-blur md:hidden"
        style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
      >
        <div className="mx-auto grid max-w-md grid-cols-2 gap-3 rounded-t-[1.5rem]">
          <a
            href={`tel:${phoneNumber}`}
            onClick={() => trackPhoneClick("mobile_cta_bar")}
            className="flex min-h-[52px] items-center justify-center gap-2 rounded-2xl bg-yellow-400 px-4 py-3 text-sm font-extrabold text-black shadow-lg shadow-yellow-400/20 transition active:scale-[0.98]"
          >
            <FaPhoneAlt />
            Call Now
          </a>

          <a
            href={whatsappLink}
            onClick={() => trackWhatsAppClick("mobile_cta_bar")}
            target="_blank"
            rel="noreferrer"
            className="flex min-h-[52px] items-center justify-center gap-2 rounded-2xl bg-green-500 px-4 py-3 text-sm font-extrabold text-white shadow-lg shadow-green-500/20 transition active:scale-[0.98]"
          >
            <FaWhatsapp className="text-lg" />
            WhatsApp
          </a>
        </div>
      </div>
    </>
  );
}
